import React from 'react'
import { MenuItemsCounterProvider } from '../contexts/menuItemsCounterContext'
import Layout from './layout/layout'
import LoadingFallback from './LoadingFallback'



function LoadingLayoutWrapper() {
  return (
    <MenuItemsCounterProvider>
    <Layout>
      <LoadingFallback />
    </Layout>
  </MenuItemsCounterProvider>
  )
}

export default LoadingLayoutWrapper